import React from "react";
import styled, { css } from "styled-components";

import { Icons } from "src/library/components/Icon/types";

import { IconSelect } from "../CreateDashboardWidgetToolbar/IconSelect";

export type GraphDataType = "value" | "total";

export interface WidgetTotalValueSwitcherProps {
  graphDataType: GraphDataType;
  updateGraphDataType: (graphDataType: GraphDataType) => void;
  valueIcon?: Icons.CURRENCYPOUND | Icons.PENDING
}

const WidgetTotalValueSwitcher: React.FunctionComponent<WidgetTotalValueSwitcherProps> = ({
  graphDataType, updateGraphDataType, valueIcon = Icons.CURRENCYPOUND
}) => {
  return (
    <StyledWrapper className="widget-total-value-switcher">
      <IconSelect
        selected={graphDataType === "value"}
        icon={valueIcon}
        onClick={() => updateGraphDataType("value")}
        iconSize={35}
      />

      <IconSelect
        className="total"
        selected={graphDataType === "total"}
        icon={Icons.NUMBERS}
        onClick={() => updateGraphDataType("total")}
        iconSize={35}
      />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    width: 80px;
    display: flex;
    justify-content: space-between;

    .total {
      .icon {
        padding: ${theme.spacing.padding.xs};
      }
    }
  `}
`;

export default WidgetTotalValueSwitcher;